import { Box, Typography, Stack } from '@mui/material';
import React, { FC } from 'react';
import { AccountBalance as AccountBalanceIcon } from '@mui/icons-material';

interface AccountPendingCardProps {
  participant: {
    name: string;
    email: string;
  };
}

export const AccountPendingCard: FC<AccountPendingCardProps> = ({ participant }) => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" sx={{ minHeight: '100vh' }}>
      <Box
        sx={{
          width: '100%',
          maxWidth: 700,
          textAlign: 'center',
          boxShadow: '2px 2px 10px 0px #0000000D',
          borderRadius: 2,
          p: 4,
        }}
      >
        <Stack spacing={3} alignItems="center">
          <Box
            sx={{
              p: 1.5,
              bgcolor: '#F2F4F8',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 64,
              height: 64,
            }}
          >
            <AccountBalanceIcon sx={{ color: '#115398', fontSize: 32 }} />
          </Box>

          <Typography variant="h4" fontWeight={600}>
            Pronto!
          </Typography>

          <Typography>As informações já foram encaminhadas para a instituição financeira.</Typography>

          <Typography>
            Em até <b>15 minutos</b> o seguinte sócio/representante irá receber um e-mail para finalizar o procedimento e realizar a
            biometria:
          </Typography>

          <Box>
            <Typography fontWeight={600}>{participant.name || 'Nome do Sócio'}</Typography>
            <Typography variant="body2" color="text.secondary">
              {participant.email || 'email@email.com'}
            </Typography>
          </Box>

          <Typography variant="body2" color="text.secondary">
            Sendo necessária qualquer informação adicional, iremos entrar em contato.
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};
